// Import enumerations.
import {
	NewBusinessApplicationSectionName,
} from '@app/enumerations';
// Import api models.
import EligibilityStatus from './EligibilityStatus';
import NewBusinessApplicationStatusInfo from './NewBusinessApplicationStatusInfo';
import Section from './Section';

export default class NewBusinessApplicationStatusSummary {
	public status: NewBusinessApplicationStatusInfo | null = null;
	public eligibility: EligibilityStatus | null = null;
	public sections: Section<NewBusinessApplicationSectionName>[] = [];
	public applicationAraDecisionReasons: string[] = [];
	public isApplicationDocumentAvailable: boolean | null = null;

	public constructor() {

	}
};